import rgArticle1 from './rg-article-1.webp';
import rgArticle2 from './rg-article-2.webp';
import rgArticle4 from './rg-article-4.webp';
import rgArticle5 from './rg-article-5.webp';
import rgCheck from './rg-check.webp';
import rgHeader from './rg-header.webp';
import levelUpCover from './wow-bg-7.webp';
import privacyCover from './wow-bg-3.webp';
import crystals from './wow-bg-2.webp';

export default {
  rgArticle1,
  rgArticle2,
  rgArticle4,
  rgArticle5,
  rgCheck,
  rgHeader,
  levelUpCover,
  privacyCover,
  crystals,
};
